import React, { useState } from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { siteContent } from '../data/mock';

const FAQSection = () => {
  const { faq } = siteContent;
  
  return (
    <section className="faq-section section-padding" data-testid="faq-section">
      <div className="container">
        <h2 className="section-title-center">Perguntas Frequentes</h2>
        <div className="faq-container">
          <Accordion type="single" collapsible className="faq-accordion">
            {faq.map((item, index) => (
              <AccordionItem key={index} value={`item-${index}`}>
                <AccordionTrigger className="faq-question">
                  {item.question}
                </AccordionTrigger>
                <AccordionContent className="faq-answer">
                  {item.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
